<template lang="pug">
.photo-block
    .photo-block__image-wrapper
        SvUpload(
            :preview="uploadedImage || value.small_image || value.original_image"
            withRemove
            @input="val => change('original_image', val)"
            @remove="remove"
        )

    .photo-block__inputs
        SvInput.photo-block__input(
            :value="value.title"
            :withIcon="false"
            placeholder="title"
            @input="val => change('title', val)"
        )

        SvInput.photo-block__input(
            :value="value.alt"
            :withIcon="false"
            placeholder="alt"
            @input="val => change('alt', val)"
        )
</template>

<script>
/**
 * @param {Object} [value] - required - Объект с полями:
 * @field {String} [original_image] - required - Изображение, base64 или ссылка
 * @field {String} [title=''] - Название изображения
 * @field {String} [alt=''] - Альтернативный текст картинки
 */
import SvUpload from '@/components/uikit/SvUpload.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvInput from '@/components/uikit/SvInput.vue';

export default {
  name: 'PhotoBlock',

  data(){
    return{
      uploadedImage: null
    }
  },

  props: {
    value: {
      type: Object,
      required: true,
    },
  },

  methods: {
    change(field, val) {
      if (field === 'original_image') {
        this.uploadedImage = val;
      }

      this.$emit('input', {
        ...this.value,
        [field]: val,
      });
    },

    remove() {
      this.$emit('remove');
    }
  },
  
  mounted() {
  },

  components: {
    SvInput,
    SvButton,
    SvUpload,
  },
};
</script>

<style lang="scss" scoped>
.photo-block__inputs {
    margin-top: 25px;
}

.photo-block__input:last-child {
    margin-top: 20px;
}
</style>
